module.exports = __webpack_public_path__ + "img/sdg_es_(6).23f4c369.png";